<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
         <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
          <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
            <template v-slot:item="{ item }">
              <tr :id="'r-'+item.ID">
                <td>{{ item.PackageCode }}</td>
                <td class="text-right">{{ item.NumberOfPack | currency }}</td>
                <td class="text-right">{{ item.TotalCode | currency }}</td>
                <td v-bind:style="{ 'color': text_color(item.Status, listStatus)}">{{ item.Status | display_value(listStatus)  }}</td>
                <td class="text-center" v-if="userRole !== 0">
                  <v-icon medium class="mr-2" @click="gotoDetail(item.ID)">edit</v-icon>
                  <v-icon v-if="userRole===1" medium @click="deleteItem(item.ID)">delete</v-icon>
                </td>
              </tr>
            </template>
            <template v-slot:body.append>
              <tr class="total-summary-td" v-if="summary">
                  <td colspan="1" class="text-center font-weight-bold">Tổng</td>
                  <td class="text-end font-weight-bold">{{ summary.NumberOfPack | currency}}</td>
                  <td class="text-end font-weight-bold">{{ summary.TotalCode | currency}}</td>
                  <td></td>
                  <td></td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
      <big-package-popup
        :dialogPackageDetail="dialogPackageDetail"
        v-on:closePopup="closePopup"
        v-on:closeSavePopup="closePopup(true)"
        @deleteItem="deleteItem"
      ></big-package-popup>
    </v-layout>
    <v-dialog v-model="dialogImport" persistent fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="oee-theme">
          <v-btn icon dark @click="dialogImport = false">
            <v-icon>fa-times-circle</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-toolbar-title>Import thông tin kiện</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex lg6 md6 sm12 pt-3 v-if="importStep == 0">
                <v-autocomplete label="Lô hàng" v-model="importPackageID" :items="unpaidPackages" item-text="PackageCode" item-value="ID"></v-autocomplete>
              </v-flex>
              <v-flex lg12 md12 sm12 pt-3 v-if="importStep == 0">
                <a href="/hhe_template.xlsx">File mẫu</a>
                <v-textarea outlined rows='20' label="Copy dữ liệu từ excel" v-model="dataImport"></v-textarea>
              </v-flex>
              <v-flex lg12 md12 sm12 pt-3 v-else>
                <v-data-table :headers="importHeaders" :items="importItems" :items-per-page="5" class="elevation-1"></v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1 white--text" @click="importPreview()" v-if="importStep == 0">Tiếp theo</v-btn>
          <v-btn color="blue darken-1 white--text" @click="importStep = 0" v-if="importStep == 1">Quay lại</v-btn>
          <v-btn color="red darken-1 white--text" @click="importTransaction" v-if="importStep == 1">Nhập dữ liệu</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="appLoading" z-index="999999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import big_package from "@/components/popups/big_package";
import Filtering from "@/components/Filtering";
import { sendErrorNotice } from "@/commons/utils";
import { request_detail } from '@/commons/hpod';
import Vue from 'vue';
import { currency } from "@/commons/currency";
import moment from "moment";
import _ from "lodash";

export default {
  components: {
    "hpo-filter": Filtering,
    "big-package-popup": big_package,
  },
  data() {
    return {
      pagination: {...configs.PAGINATION},
      items_per_page: {...configs.ITEMS_PER_PAGE},
      viewName: "bigpackage_list",
      filterConditions: [],
      quickFilterConditions: [],
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      dialogPackageDetail: false,
      listStatus: configs.BIGPACKAGE_STATUS,
      product_types: configs.PRODUCT_TYPE,
      shipping_methods: configs.SHIPPING_METHOD,
      package_status: configs.PACKAGE_STATUS,
      importPackageID: 0,
      dialogImport: false,
      dataImport: '',
      importStep: 0,
      appLoading: false,
      importHeaders: [
        {
          text: "Mã kiện",
          value: "TransactionCode"
        },
        {
          text: "Cân nặng",
          value: "Weight"
        },
        {
          text: "Chiều dài",
          value: "Length"
        },
        {
          text: "Chiều rộng",
          value: "Width"
        },
        {
          text: "Chiều cao",
          value: "Height"
        },
        {
          text: "Ship nội địa",
          value: "FeeShip"
        },
        {
          text: "Phí ship TQ-VN",
          value: "FeeShipCNVN"
        },
        {
          text: "Phí phát sinh",
          value: "FeeOther"
        },
        {
          text: "Hình thức vận chuyển",
          value: "ShippingMethod"
        },
        {
          text: "Loại hàng",
          value: "ProductType"
        },
        {
          text: "Trạng thái",
          value: "Status"
        }
      ],
      importItems: []
    };
  },
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions)
          ? filterConditions[this.viewName]
          : [];
        this.filter_data();
      },
      deep: true
    }
  },
  computed: {
    ...mapState({
      items: state => state.bigPackage.all.data,
      unpaidPackages: state => state.bigPackage.unpaid,
      total_rows: state => state.bigPackage.all.total,
      summary: state => state.bigPackage.all.summary,
      currentItem: state => state.bigPackage.selected,
      loading: state => state.bigPackage.loading,
      customers: state => state.customer.all.data,
    }),
    userRole() {
      return this.$store.state.authentication.user.roleid;
    },
    headers() {
      let hd = [
        {
          text: "Mã bao hàng",
          value: "PackageCode",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Tổng kiện",
          value: "NumberOfPack",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Tổng mã",
          value: "TotalCode",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Trạng thái",
          value: "Status",
          filterable: true,
          dataType: configs.DATA_TYPE["Enum"],
          values: configs.BIGPACKAGE_STATUS
        },
        {
          text: "Thao tác",
          value: "",
          align: "center",
          sortable: false,
          filterable: false
        }
      ];
      return hd;
    }
  },
  methods: {
    getCustomer(id) {
      let item = _.find(this.customers, {'ID': id});
      return item ? item.FullName : ''
    },
    printLabel(item) {
      request_detail('bigpackage', item => {
        let currentItem = item.data;
        var mywindow = window.open("", "PRINT");
        mywindow.document.write(`<html> <head> <title></title> <style> .row { display: flex; } .flex { flex: 1 1 auto; } .flex.lg6 { flex-basis: 50%; flex-grow: 0; max-width: 50%; } .flex.lg12 { flex-basis: 100%; flex-grow: 0; max-width: 100%; } .title { font-size: 24px; font-weight: bold; text-align: center; margin: 5px 0 3px 0 !important; } .sub-title { font-size: 16px; font-weight: bold; margin: 0 0 8px 0 !important; } .l-text { text-align: left; } .r-text { text-align: right; } .note-text { font-size: 14px; font-weight: bold; font-style: italic; text-align: center; } table { border-collapse: collapse; width: 100%; } td, th { border: 1px solid #dddddd; text-align: left; padding: 8px; } tr, td, th { page-break-inside: avoid !important; } @media print { @page { size: landscape; margin: 10mm 15mm 10mm 15mm; } html { background-color: #FFFFFF; margin: 0px; } body { margin: 0mm 0mm 0mm 0mm; } } </style> </head> <body style='width:297mm' data-new-gr-c-s-check-loaded="14.980.0" data-gr-ext-installed="">`)
        let table_content = ``;
        if(currentItem.Packages) {
          for (let i = 0; i < currentItem.Packages.length; i++) {
            const element = currentItem.Packages[i];
            table_content = table_content + `<tr>
            <td>${element.TransactionCode}</td>
            <td class='body-text r-text'>${this.$options.filters.currency(element.Weight, '', 1)}</td>
            <td class='body-text r-text'>${ element.Length ? element.Length + ' x ' + element.Width + ' x ' + element.Height : '' }</td>
            <td class='body-text r-text'>${this.$options.filters.currency(element.Volume, '', 2)}</td>
            <td class='body-text r-text'>${this.$options.filters.currency(element.FeeShipVND)} (${this.$options.filters.currency(element.FeeShip, '¥', 1)})</td>
            <td class='body-text r-text'>${this.$options.filters.currency(element.FeeOther)}</td>
            <td class='body-text r-text'>${this.$options.filters.currency(element.FeeShipCNVN)}</td>
            <td class='body-text r-text'>${this.$options.filters.currency(element.FeeShipVND+element.FeeOther+element.FeeShipCNVN)}</td>
            </tr>`;
          }
        }
        
        mywindow.document.write(`<div class="layout wrap">
          <div class="flex lg12">
              <p class="title">${currentItem.PackageCode}</p>
          </div>
          <div class="row">
              <div class="flex lg6">
                  <p class="sub-title l-text">Khách hàng</p>
              </div>
              <div class="flex lg6">
                  <p class="sub-title r-text">${this.getCustomer(currentItem.UID)}</p>
              </div>
          </div>
          <div class="row">
              <div class="flex lg6">
                  <p class="sub-title l-text">Hình thức vận chuyển</p>
              </div>
              <div class="flex lg6">
                  <p class="sub-title r-text">${this.$options.filters.display_value(currentItem.ShippingMethod, this.shipping_methods)}</p>
              </div>
          </div>
          <div class="row">
              <div class="flex lg6">
                  <p class="sub-title l-text">Tổng kiện</p>
              </div>
              <div class="flex lg6">
                  <p class="sub-title r-text">${this.$options.filters.currency(currentItem.NumberOfPack)}</p>
              </div>
          </div>
          <div class="row">
              <div class="flex lg6">
                  <p class="sub-title l-text">Tổng cân</p>
              </div>
              <div class="flex lg6">
                  <p class="sub-title r-text">${this.$options.filters.currency(currentItem.Weight, '', 1)} kg</p>
              </div>
          </div>
          <div class="row">
              <div class="flex lg6">
                  <p class="sub-title l-text">Tổng khối</p>
              </div>
              <div class="flex lg6">
                  <p class="sub-title r-text">${this.$options.filters.currency(currentItem.Volume, '', 2)} m³</p>
              </div>
          </div>
          <div class="row">
              <div class="flex lg6">
                  <p class="sub-title l-text">Cước phí</p>
              </div>
              <div class="flex lg6">
                  <p class="sub-title r-text">${this.$options.filters.currency(currentItem.Amount)}</p>
              </div>
          </div>
          <div class="row">
              <div class="flex lg6">
                  <p class="sub-title l-text">Khuyến mãi</p>
              </div>
              <div class="flex lg6">
                  <p class="sub-title r-text">${this.$options.filters.currency(currentItem.Discount)}</p>
              </div>
          </div>
          <div class="row">
              <div class="flex lg6">
                  <p class="sub-title l-text">Thành tiền</p>
              </div>
              <div class="flex lg6">
                  <p class="sub-title r-text">${this.$options.filters.currency(currentItem.Amount-currentItem.Discount)}</p>
              </div>
          </div>
          <hr class="v-divider theme--light">
          <table>
              <tr><th>Mã kiện</th> <th class='body-text r-text'>Cân nặng</th> <th class='body-text r-text'>Kích thước</th> <th class='body-text r-text'>Số khối</th> <th class='body-text r-text'>Ship nội địa</th> <th class='body-text r-text'>Phát sinh</th> <th class='body-text r-text'>Ship TQ-VN</th><th class='body-text r-text'>Tổng phí</th></tr>
              ${table_content}
          </table>
          <hr class="v-divider theme--light">
          <div class="flex lg12">
              <p class="note-text">tracuumavandon.com</p>
          </div>
      </div>`);
        mywindow.document.write("</body></html>");
        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/
        mywindow.print();
            
        }, Vue.http, item.ID, this.$store.state.authentication.token);

      // mywindow.document.write("<html><head><title></title>");
      // mywindow.document.write(
      //   "<style>.row {display: flex;}.flex {flex: 1 1 auto;}.flex.lg6 {flex-basis: 50%;flex-grow: 0;max-width: 50%;}"
      // );
      // mywindow.document.write(
      //   ".flex.lg12 {flex-basis: 100%;flex-grow: 0;max-width: 100%;}.title {font-size: 24px; font-weight: bold; text-align: center; margin: 5px 0 3px 0 !important;}"
      // );
      // mywindow.document.write(
      //   ".sub-title {font-size: 16px; font-weight: bold; margin: 0 0 8px 0 !important;}.l-text {text-align: left;}.r-text {text-align: right;}.note-text {font-size: 14px; font-weight: bold; font-style: italic; text-align: center;}"
      // );
      // mywindow.document.write(
      //   "</style></head><body style='height:8cm; width:9cm; margin-left: 5px; margin-right:5px;'>"
      // );
      // mywindow.document.write("<div class='layout wrap'>");
      // mywindow.document.write(
      //   `<div class='flex lg12'><p class='title'>${packageCode}</p></div>`
      // );
      // mywindow.document.write(
      //   `<div class='row'><div class='flex lg6'><p class='sub-title l-text'>Khối lượng</p></div><div class='flex lg6'><p class='sub-title r-text'>${currency(weight)} kg</p></div></div>`
      // );
      // mywindow.document.write(
      //   `<div class='row'><div class='flex lg6'><p class='sub-title l-text'>Số kiện</p></div><div class='flex lg6'><p class='sub-title r-text'>${currency(volume)}</p></div></div>`
      // );
      // mywindow.document.write(
      //   `<div class='row'><div class='flex lg6'><p class='sub-title l-text'>Ngày tạo</p></div><div class='flex lg6'><p class='sub-title r-text'>${moment(
      //     new Date()
      //   ).format("DD-MM-YYYY")}</p></div></div>`
      // );
      // mywindow.document.write(`<hr class='v-divider theme--light'>`);
      // mywindow.document.write(
      //   `<div class='flex lg12'><p class='note-text'>tracuumavandon.com</p></div>`
      // );
      // mywindow.document.write("</div>");
      // mywindow.document.write("</body></html>");
      
      // mywindow.close();
      return true;
    },
    filter_data: function() {
      this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: this.userRole === 0, invisibleimportButton: this.userRole === 0, invisibleexportButton: this.userRole === 0});
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      this.$store.dispatch("bigPackage/getList", param);
      var param_unpaid = {
        filter: [
          {
            column: "Status",
            value: [0],
            condition: "in"
          }
        ]
      };
      this.$store.dispatch("bigPackage/getListUnpaid", param_unpaid);
      this.appLoading = false;
    },
    gotoDetail: function(id) {
      this.$store.dispatch("bigPackage/getDetail", {'id': id});
      setTimeout(() => {this.dialogPackageDetail = true}, 200);
    },
    deleteItem: function(id) {
      window.getApp.$emit("REQUEST_DELETE_DATA", id);
    },    
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    createData(username = "") {
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      this.$store.commit("bigPackage/setDetail", {
        'data': {
          ID: 0,
          PackageCode: '',
          Weight: 0,
          Volume: 0,
          Amount: 0,
          Status: 0,
          Packages: []
        },
        'param': param
      });
      this.dialogPackageDetail = true;
    },
    saveItem(item) {
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      this.$store.dispatch("bigPackage/setDetail", {
        'data': item,
        'id': item.ID,
        'param': param
      });
    },
    saveData() {
      this.saveItem(this.currentItem);
      this.dialogPackageDetail = false;
    },
    closePopup(isRefreshData = false) {
      this.dialogPackageDetail = false;
      if (isRefreshData) {
        this.filter_data();
      }
    },
    text_color(val, enums) {
      return this.$options.filters.display_color(val, enums);
    },
    import_show() {
      this.dataImport = '';
      this.importItems = [];
      this.dialogImport = true;
    },
    importPreview(){
      this.importItems = [];
      let rows = this.dataImport.split("\n");
      if(rows.length <= 1){
        sendErrorNotice('Không tìm thấy dữ liệu import.')
        return;
      }
      let header = rows[0].split("\t");
      let props = [];
      for (let i = 0; i < header.length; i++) {
        let element = _.find(this.importHeaders, function (item) {
          return item.text.toLowerCase() === header[i].toLowerCase();
        });
        props.push(element ? element.value : 'unknown');
      }

      if(!props.includes('TransactionCode')) {
        sendErrorNotice('Không tìm thấy dữ liệu import.')
        return;
      }
      this.importStep = 1;
      for (let i = 1; i < rows.length; i++) {
        let item = rows[i].split("\t");
        if(item.length == 0 || item[0] == '') {
          continue;
        }
        let importItem = {};
        for (let j = 0; j < props.length; j++) {
          let prop = props[j];
          if(prop !== 'unknown') {
            let val = item[j].replace(/\s+/g, ' ').trim();
            if(val != '') {
              importItem[prop] = val;
            }
          }
        }
        this.importItems.push(importItem);
      }
    },
    importTransaction() {
      this.importItems.forEach(element => {
        if(element.Status) {
          let conf = _.find(this.package_status, function (item) {
            let ret = item.name.normalize('NFD').toLowerCase() === element.Status.normalize('NFD').toLowerCase();
            return ret;
          });
          if(conf) {
            element.Status = conf.value;
          }
          else {
            delete element.Status;
          }
        }
        if(element.ProductType) {
          let conf = _.find(this.product_types, function (item) {
            return item.name.normalize('NFD').toLowerCase() === element.ProductType.normalize('NFD').toLowerCase();
          });
          if(conf) {
            element.ProductType = conf.value;
          }
          else {
            delete element.ProductType;
          }
        }
        if(element.ShippingMethod) {
          let conf = _.find(this.shipping_methods, function (item) {
            return item.name.normalize('NFD').toLowerCase() === element.ShippingMethod.normalize('NFD').toLowerCase();
          });
          if(conf) {
            element.ShippingMethod = conf.value;
          }
          else {
            delete element.ShippingMethod;
          }
        }
        if(this.importPackageID > 0) {
          element.BigPackageID = this.importPackageID;
          let importBigPackage = _.find(this.unpaidPackages, {'ID': this.importPackageID});
          element.UID = importBigPackage ? importBigPackage.UID : 0;
        }
      });
      this.appLoading = true;
      this.$store.dispatch("storeManager/import", this.importItems);
      this.dialogImport = false;
      this.importStep = 0;
      this.importPackageID = 0;
    }
  },
  mounted() {
    this.$store.dispatch("customer/getCustomerList", { is_master: 1, fields: ["ID", "FullName"] });
    this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: this.userRole === 0, invisibleimportButton: this.userRole === 0, invisibleexportButton: this.userRole === 0});
    this.$root.$on("REQUEST_CREATE_DATA", this.createData);
    this.$root.$on("REQUEST_IMPORT_DATA", this.import_show);
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    var param = {
      pagination: this.pagination,
      filter: this.filterConditions,
      quickFilter: this.quickFilterConditions
    };
    this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
      this.$store.dispatch("bigPackage/removeDetail", {'id': id, 'param': param});
    });
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_CREATE_DATA", this.createData);
    this.$root.$off("REQUEST_IMPORT_DATA", this.import_show);
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$off("CONFIRMED_REMOVE_DATA");
  }
};
</script>
